import { Pipe, PipeTransform } from '@angular/core';
import { PRINTED } from '../../../ngrx/status-types';

@Pipe({
  name: 'jobMachine'
})
export class JobMachinePipe implements PipeTransform {
  transform(jobs: any[], machine: string): any[] {
    return jobs.filter(job => {
      if(job.cutting) {
        return job.cutting === machine && job.status !== 'shipping';
      } else {
        if(job.product){
          return job.product.cutting === machine && job.status !== 'shipping';
        }
      }
    });
  }
}


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/pipes/job-machine.pipe.ts